export default function ServicesHero() {
  return (
    <section className="py-36 bg-gradient-to-b from-[#0A1F1F] to-[#0D9488]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-4xl">
          <span className="text-sm font-medium text-[#5EEAD4] mb-4 block">사업 영역</span>
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-8">
            AI · 데이터 · R&D<br />
            전문 기술 서비스
          </h1>
          <p className="text-lg text-gray-200 leading-relaxed">
            공공기관과 기업의 실질적인 문제를 해결하기 위한<br />
            연구개발 기반의 기술 솔루션을 제공합니다.
          </p>
        </div>
      </div>
    </section>
  );
}
